__turbopack_context__.v({
  "infoContainer": "SongDisplay-module__tbB6aa__infoContainer",
  "songAlbum": "SongDisplay-module__tbB6aa__songAlbum",
  "songArtist": "SongDisplay-module__tbB6aa__songArtist",
  "songDisplay": "SongDisplay-module__tbB6aa__songDisplay",
  "songName": "SongDisplay-module__tbB6aa__songName",
  "songVotes": "SongDisplay-module__tbB6aa__songVotes",
  "songVotesItem": "SongDisplay-module__tbB6aa__songVotesItem",
  "songVotesItemDownvotes": "SongDisplay-module__tbB6aa__songVotesItemDownvotes",
  "songVotesItemIcon": "SongDisplay-module__tbB6aa__songVotesItemIcon",
  "songVotesItemUpvotes": "SongDisplay-module__tbB6aa__songVotesItemUpvotes",
  "songVotesItemVoteTotal": "SongDisplay-module__tbB6aa__songVotesItemVoteTotal",
  "songVotesItemVoters": "SongDisplay-module__tbB6aa__songVotesItemVoters",
  "songVotesSeparator": "SongDisplay-module__tbB6aa__songVotesSeparator",
});
